import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class NumberDisplay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    NumberDisplay.instances.push(this);
    this.once(Phaser.GameObjects.Events.DESTROY, () => Phaser.Utils.Array.Remove(NumberDisplay.instances, this));

    this.menuX = 0;
    this.menuY = 0;

    this.offsetX = 0;
    this.offsetY = 0;

    this.bg1 = null;
    this.bg2 = null;
    this.lbl = null;
    this.num = null;
    this.blinkSwitch = false;

    this.placedIndex = null;

    this.workingWidth = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._outside_circle).realWidth;
    this.workingHeight = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._outside_circle).realHeight;
  }

  blinkOff () {
    this.blinkSwitch = false;
    this.scene.tweens.killTweensOf(this.bg2);
    this.bg2.alpha = 0;
  }

  reset (num,x,y, shadow) {
    this.shadow = shadow;
    this.shadow.x = x;
    this.shadow.y = y + 36;
    this.bg1 = ABCyaPhaser.Images.addImage(0,0,`num-${num}`, this);
    this.bg2 = ABCyaPhaser.Images.addImage(0,0,`num-${num}b`, this);

    this.bg2.alpha = 0;

    this.num = num;

    this.menuX = x;
    this.x = x;
    this.menuY = y;
    this.y = y;
  }

  updateShadow(currentY, targetY) {
    const distanceAway = targetY - currentY;
    const maxDistance = 20;
    if (distanceAway > maxDistance) {
      this.shadow.setScale(0).setAlpha(0);
    }
    else {
      const alpha = Phaser.Math.FromPercent((maxDistance - distanceAway) / maxDistance, 0, 1);
      this.shadow.alpha = alpha;
      const scale = Phaser.Math.FromPercent((maxDistance - distanceAway) / maxDistance, 0.25, 1);
      this.shadow.scale = scale;
    }
  }

  blinkOn () {
    this.blinkSwitch = true;

    NumberDisplay.blinkSelected();
  }

  blink (delay = 0) {
    this.blinkSwitch = true;
    this.blinkOff();
    ABCyaPhaser.Tweens.addTween(this.bg2, 200, { delay, alpha: 1, yoyo: true, repeat: -1, hold: NumberDisplay.delay, repeatDelay: NumberDisplay.delay }, Phaser.Math.Easing.Linear);
  }

  /** @type {NumberDisplay[]} */
  static instances = [];

  static delay = 200;

  static allLightsOn () {
    const len = NumberDisplay.instances.length;

    for (let i = 0; i < len; i++) {
      const thisOne = NumberDisplay.instances[i];

      if (thisOne.blinkSwitch) {
        thisOne.blinkOff();
      }
      if (thisOne.bg2 !== null) {
        thisOne.bg2.alpha = 1;
      }
    }
  }

  static allBlinkOff () {
    const len = NumberDisplay.instances.length;

    for (let i = 0; i < len; i++) {
      const thisOne = NumberDisplay.instances[i];
      if (thisOne.blinkSwitch) {
        thisOne.blinkOff();
      }
    }
  }

  static blinkSelected () {
    const len = NumberDisplay.instances.length;

    // first count how many are supposed to blink to calculate delay
    // we'll blink faster with more balls placed on puzzle
    let count = 0;
    for (let i = 0; i < len; i++) {
      const thisOne = NumberDisplay.instances[i];
      if (thisOne.blinkSwitch) {
        count++;
      }
    }

    // there's a maximum of 9 balls, always use 9 even if there aren't 9 balls
    NumberDisplay.delay = ((9 - count) * 50) + 50;

    for (let i = 0; i < len; i++) {
      const thisOne = NumberDisplay.instances[i];

      if (thisOne.blinkSwitch) {
        thisOne.blinkOff();
        thisOne.blink(i * 200);
      }
    }
  }
}